// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 277) return "static/chunks/277.aaa062c3263becc3.js";
	if (chunkId === 773) return "static/chunks/video-players-f0652545.6b00e57d800deb9b.js";
	if (chunkId === 89) return "static/chunks/video-players-faf47f09.9a5ce8e3963699a0.js";
	if (chunkId === 461) return "static/chunks/polyfills.17a7c0d28fc61c6e.js";
	if (chunkId === 618) return "static/chunks/618.8d669c7a7a2e37ce.js";
	// return url for filenames based on template
	return "static/chunks/" + {"76":"common","108":"magalu-libs-1ac24d32","143":"magalu-libs-2b642a53","156":"magalu-libs-1b3faf5b","413":"magalu-libs-51c13596","813":"magalu-components"}[chunkId] + "-" + {"76":"e9045928bb0d3d6c","108":"dea44f383a66043e","143":"d781fd5ec73e81ec","156":"76f8ddfd03f2fc8f","413":"b6ef0b51bd5b68c9","813":"844b22529fefdd64"}[chunkId] + ".js";
};